import React, { Fragment } from 'react'
import { Grid2 as Grid, MenuItem, TextField } from '@mui/material'
import { CourierServiceGridDto } from '../../config/config'

interface CourierServiceHeaderFieldsProps {
  courier: CourierServiceGridDto
  maxUnitsCapacity: string
  maxPackagesCapacity: string
  isMaxUnitsCapacityInvalid: boolean
  isMaxPackagesCapacityInvalid: boolean
  onMaxUnitsCapacityChange: (value: string) => void
  onMaxPackagesCapacityChange: (value: string) => void
}

export const CourierServiceHeaderFields: React.FC<CourierServiceHeaderFieldsProps> = ({
  courier,
  maxUnitsCapacity,
  maxPackagesCapacity,
  isMaxUnitsCapacityInvalid,
  isMaxPackagesCapacityInvalid,
  onMaxUnitsCapacityChange,
  onMaxPackagesCapacityChange
}) => (
  <Fragment>
    <Grid size={{ xs: 12, sm: 6 }}>
      <TextField
        select
        fullWidth
        variant='outlined'
        label='Nombre del Courier'
        value={courier.courierName}
        disabled
      >
        <MenuItem value={courier.courierName}>{courier.courierName}</MenuItem>
      </TextField>
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <TextField
        fullWidth
        variant='outlined'
        label='Nombre del Servicio'
        value={courier.name}
        disabled
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <TextField
        fullWidth
        type='number'
        variant='outlined'
        label='Capacidad Máxima de Unidades'
        placeholder='Ej: 500'
        value={maxUnitsCapacity}
        error={isMaxUnitsCapacityInvalid}
        helperText={isMaxUnitsCapacityInvalid ? 'Debe ser mayor a 0' : undefined}
        inputProps={{ min: 1 }}
        onChange={(e) => onMaxUnitsCapacityChange(e.target.value)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <TextField
        fullWidth
        type='number'
        variant='outlined'
        label='Capacidad Máxima de Paquetes'
        placeholder='Ej: 200'
        value={maxPackagesCapacity}
        error={isMaxPackagesCapacityInvalid}
        helperText={isMaxPackagesCapacityInvalid ? 'Debe ser mayor a 0' : undefined}
        inputProps={{ min: 1 }}
        onChange={(e) => onMaxPackagesCapacityChange(e.target.value)}
      />
    </Grid>
  </Fragment>
)
